export default __webpack_public_path__ + "static/media/mostly-sunny.67431bdd.jpg";